
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iforklift/privacy-policy",
      function () {
        return require("private-next-pages/iforklift/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iforklift/privacy-policy"])
      });
    }
  